'use client'

import HelpIcon from '@mui/icons-material/HelpOutline'
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Modal,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { useState } from 'react'

export const HelpContent = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      {/* Desktop icon */}
      {isDesktop && (
        <Tooltip title="Súgó" sx={{ marginLeft: '97%', marginTop: -10 }} enterTouchDelay={0}>
          <IconButton onClick={handleOpen}>
            <HelpIcon />
          </IconButton>
        </Tooltip>
      )}

      {/* Mobile app bar */}
      {!isDesktop && (
        <AppBar position="absolute" sx={{ border: 0, borderRadius: 0 }}>
          <Toolbar sx={{ minHeight: '32px', justifyContent: 'flex-end' }}>
            <Button color="inherit" onClick={handleOpen}>
              Súgó
            </Button>
          </Toolbar>
        </AppBar>
      )}

      {/* Content */}
      <Modal open={open} onClose={handleClose} sx={{ overflow: 'scroll' }}>
        <Container
          sx={{
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 5,
            marginBottom: 'auto',
          }}
        >
          <Paper sx={{ padding: isDesktop ? 10 : 3 }}>
            <Typography variant="h1" color="primary" mb={2}>
              Oldal bemutatása
            </Typography>
            <Typography variant="body2" mb={2}>
              Ezen az oldalon van lehetőség az eseményhez kapcsolódó szabad időpontokat lefoglalni,
              így a szűrésen részt venni.
            </Typography>
            <Typography variant="body2" fontWeight={600} mb={2}>
              Foglalás lépései:
            </Typography>
            <Typography variant="body2">
              1. Válassza ki, hogy melyik szűrésre szeretne időpontot foglalni.
            </Typography>
            <Typography variant="body2" mb={2}>
              2. A szabad időpontok közül válasszon egyet, minden egyes kiválasztott szűrés esetén.
            </Typography>
            <Typography variant="body2" mb={2}>
              <span style={{ fontWeight: 600 }}>Fontos:</span> egy vizsgálatra, csak egy időpontot
              van lehetőség választani. A választott időpont foglalása 5 percig érvényes, így az
              első időpont kiválasztása után ennyi idő áll rendelkezésre a további időpont
              választására, az adatok megadására és a foglalás véglegesítésére.
            </Typography>
            <Typography variant="body2">
              3. Adja meg a személyes adatait utolsó lépésként és véglegesítse a választott
              időpontok foglalását.
            </Typography>
            <Typography variant="body2">• Telefonszámnál elvárt formátum: +36201234567</Typography>
            <Typography variant="body2" mb={4}>
              • E-mail címnél elvárt formátum: john@email.com
            </Typography>
            <Typography variant="h1" color="primary" mb={2}>
              Gyakori kérdések
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Hány darab szűrést lehet választani?
            </Typography>
            <Typography variant="body2" mb={2}>
              Akár az összes szűrést ki lehet választani és foglalni a szabad időpontok közül.
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Mi történik az 5 perc lejárta után?
            </Typography>
            <Typography variant="body2" mb={2}>
              Feloldásra kerül a foglalás, ami így mások számára is elérhető lesz.
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Miért nem tudok bizonyos időpontot kiválasztani?
            </Typography>
            <Typography variant="body2" mb={2}>
              Korábban lefoglalásra kerültek, a rendszer csak a szabad időpontokat engedi
              kiválasztani.
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Miért van szükség a személyes adatokra?
            </Typography>
            <Typography variant="body2" mb={2}>
              vizsgálatoknál a személyes adatok segítségével történik a beazonosítás.
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Miért érdemes a privát e-mail címet megadni?
            </Typography>
            <Typography variant="body2" mb={2}>
              A vizsgálatok során elkészült személyes dokumentumokat emailben továbbítjuk, így
              javasoljuk a személyes email cím használatát. Továbbá a céges levelezőrendszerek, nem
              minden esetben kezelik jól a csatolmánnyal rendelkező leveleket.
            </Typography>
            <Typography variant="body2" fontStyle="italic">
              Le tudom mondani a foglalást?
            </Typography>
            <Typography variant="body2" mb={2}>
              Igen, a sikeres foglalást megerősítő emailben található link segítségével. Fontos a
              lemondást nem lehet visszavonni, de új időpontot lehet foglalni az adott eseményre.
            </Typography>
            <Box sx={{ textAlign: 'right' }}>
              <Button variant="contained" color="primary" size="large" onClick={handleClose}>
                Rendben
              </Button>
            </Box>
          </Paper>
        </Container>
      </Modal>
    </>
  )
}
